import React from "react"

import { Card, Tabs } from "antd"

import { useTranslation } from "react-i18next"
import { PurchaseOrder } from "../types/PurchaseOrder.interfaces"
import { PurchaseOrderTabContent } from "./PurchaseOrderTabContent"
import { PurchaseOrderVendorTabContent } from "./PurchaseOrderVendorTabContent"

interface PurchaseOrderDetailsSectionProps {
    purchaseOrder: PurchaseOrder
}

export const PurchaseOrderDetailsSection = ({ purchaseOrder }: PurchaseOrderDetailsSectionProps) => {
    const { t } = useTranslation()

    return (
        <Card className="card-with-tabs" id="expense-source-section">
            <Tabs
                defaultActiveKey="purchaseData"
                className="mb-8"
                items={[
                    {
                        key: "purchaseOrderData",
                        label: t("label:purchase_data"),
                        children: <PurchaseOrderTabContent purchaseOrder={purchaseOrder} />,
                    },
                    {
                        key: "vendorData",
                        label: t("label:vendor_data"),
                        children: <PurchaseOrderVendorTabContent purchaseOrder={purchaseOrder} />,
                    },
                ]}
            />
        </Card>
    )
}
